import { UserStore, ReferrerStore, PagePathStore, TagStore } from '../../../shared/mixpanel';

export default {
    user: new UserStore(),
    referrer: new ReferrerStore(),
    pagePath: new PagePathStore(),
    tag: new TagStore(),
};
